import { render, staticRenderFns } from "./ChatFullscreen.vue?vue&type=template&id=e2e67718&"
import script from "./ChatFullscreen.vue?vue&type=script&lang=js&"
export * from "./ChatFullscreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports